import React from "react";
import { Card } from "./ui/card";
import { Award, Calendar, Building } from "lucide-react";
import { mockCertificates } from "../data/mock";

const Certifications = () => {
  return (
    <section id="certifications" className="py-24 bg-slate-950">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">

          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Certifications & <span className="text-blue-400">Achievements</span>
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto mb-4"></div>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Professional certifications and achievements that validate my skills
            </p>
          </div>

          {/* Certificates Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {mockCertificates.map((cert) => (
              <Card
                key={cert.id}
                className="bg-slate-900/50 border-slate-800 p-6 backdrop-blur-sm
                hover:border-blue-500/30 transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br
                from-blue-500/20 to-cyan-500/20 flex items-center justify-center mb-4">
                  <Award className="w-8 h-8 text-blue-400" />
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold text-white mb-2">
                  {cert.name}
                </h3>

                {/* Issuer */}
                <div className="flex items-center text-sm text-gray-400 mb-1">
                  <Building className="w-4 h-4 mr-2 text-blue-400" />
                  {cert.issuer}
                </div>

                {/* Date */}
                <div className="flex items-center text-sm text-gray-400">
                  <Calendar className="w-4 h-4 mr-2 text-cyan-400" />
                  {new Date(cert.date).toLocaleDateString("en-US", {
                    month: "long",
                    year: "numeric",
                  })}
                </div>

                {/* Description */}
                {cert.description && (
                  <p className="text-gray-500 text-sm mt-4">
                    {cert.description}
                  </p>
                )}
                {cert.link && (
  <a
    href={cert.link}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center mt-4 text-sm font-medium
    text-blue-400 hover:text-blue-300 transition"
  >
    View Certificate
    <svg
      className="w-4 h-4 ml-2"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M14 3h7v7" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 14L21 3" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 14v7h-7" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 10V3h7" />
    </svg>
  </a>
)}
              </Card>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Certifications;